<template>
  <div>
    <object-loading v-show="llMixin_componentIsLoading && !oephMixin_loadingError" />
    <header-layout
      v-if="!llMixin_componentIsLoading || oephMixin_loadingError"
      :object-number="objectNumber"
    />
    <div
      v-if="!llMixin_componentIsLoading && !oephMixin_loadingError"
      class="object hide-suggested-arrivals"
      :class="{'object-cancelable':cancelable}"
    >
      <object-breadcrumb v-if="hasObjectDataByKey('breadcrumb')" />

      <object-navbar
        :available-sections="availableSections"
        :sections-refs="$refs"
        :object-number="objectNumber"
        class="d-print-none"
      />
      <light-box-pinch
        v-if="showLightboxPinch"
        :object-number="objectNumber"
        :image-index-pinch-init="imageIndexPinch"
        :images-arr="galleryLightboxArr"
        @close="showLightboxPinch = false"
      />
      <main class="container">
        <article id="nav-scroller">
          <encouragement-alert
            :message="$t('common:bestOfferAlert')"
            :object-number="objectNumber"
          />
          <info-banner
            :object-data="objectData"
            :start-date="$router.currentRoute.query.startDate"
          />
          <div class="card-radius">
            <!-- AB Test Bestärkung bei guter Bewertung -->
            <div
              v-show="niceReviewText !== false"
              class=" alert alert-success mb-3 p-3"
            >
              <i class="icon">
                <icon-thumbs-up />
              </i> <b>{{ $t('object:goodChoice.goodChoice') }}</b> <span v-dompurify-html="niceReviewText" />
            </div>
            <div class="position-relative">
              <div class="object-options">
                <object-share-modal />
                <share-btn class="d-print-none" />
                <watch-btn
                  :object-number="objectNumber"
                  :extra-class="'watch-btn-object'"
                  :price-object="objectHasPriceData ? priceData.priceObject : undefined"
                  :min-price="objectData.minPrice"
                  class="d-print-none"
                />
              </div>

              <image-gallery
                :show-slider-custom="objectHasImages"
                :images-arr="objectImages"
                :object-data="objectData"
                @open-gallery="openGallery"
              />
            </div>
            <div
              v-if="printingHasError"
              class="alert alert-warning mb-3 mt-3"
              role="alert"
            >
              {{ $t('object:print.printFailed') }}
            </div>
          </div>
          <div v-if="false">
            <template v-if="hasObjectDataByKey('agency')">
              <agency-info
                :agencyid="agencyId"
                :position="objectData.position"
                :travel-persons="$store.state.objects.persons"
                :travel-startdate="$store.state.objects.startDate"
                :travel-enddate="$store.state.objects.endDate"
              />
            </template>
          </div>
          <section
            id="highlights"
            ref="sectionHighlights"
            class="has-anchor"
          >
            <div class="section-head first">
              <h1
                v-dompurify-html="objectData.title"
                :class="hsh_getHeadingClass(objectData.title, 1)"
              />
              <h2
                v-if="objectData.locations.state"
                class="h4 mt-1"
              >
                {{ objectData.locations.state }}
              </h2>
            </div>
            <div class="section-main">
              <div class="section-body">
                <stv-dtv-rating
                  v-if="objectData.objectSTV > 0"
                  method="STV"
                  :num-stars="objectData.objectSTV"
                />
                <stv-dtv-rating
                  v-if="objectData.objectDTV > 0"
                  method="DTV"
                  :num-stars="objectData.objectDTV"
                />

                <div class="section-main">
                  <div class="section-body">
                    <div class="amenities amenities-lg">
                      <object-features :long="false" />
                    </div>
                    <!-- Only commented out, because unsure what government will decide in the future -->
                    <!-- <object-rki-notes class="d-print-none" /> -->
                    <object-internals :object-number="objectData.objectNumber" />
                    <div class="badges">
                      <search-offer :ids="objectData.searchOffers" />
                    </div>
                    <!-- object-partner -->
                    <object-partner
                      v-if="showPartner"
                      :ids="objectData.searchOffers"
                      :object-number="objectData.objectNumber"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- hasObjectAexeaDesc is from ActiveObjectStore -->
          <object-aexea
            v-if="hasObjectAexeaDesc"
            :descriptions-aexea="objectData.descriptionsAexea"
            class="d-print-none"
          />
          <section
            v-if="hasObjectDataByKey('descriptionLanguages')"
            id="beschreibung"
            ref="sectionDescription"
            class="has-anchor"
          >
            <object-description :show-agency-logo="withCookieDropping" />
          </section>
          <!-- drop agency partner cookie if agency brand is visible -->
          <agency-cookie-drop
            v-if="withCookieDropping"
            :agency-number="agencyId"
          />

          <section
            id="ausstattung"
            ref="sectionFeatures"
            class="has-anchor"
          >
            <div class="section-head">
              <div class="d-flex">
                <h2 class="flex-fill">
                  {{ $t('objectDescription:interior') }}
                </h2>
              </div>
            </div>

            <div class="section-main">
              <div class="section-body">
                <div class="amenities">
                  <object-features />
                </div>

                <b-collapse
                  id="collapse-object-features"
                  v-model="interiorVisible"
                  class="mt-2"
                >
                  <section
                    v-if="objectFeatureDescription !== ''"
                    class="objectDescriptionFeatures"
                  >
                    <div v-dompurify-html="objectFeatureDescription" />
                  </section>
                </b-collapse>
              </div>
              <div
                v-show="objectFeatureDescription !== ''"
                class="section-more"
              >
                <a
                  v-b-toggle.collapse-object-features
                  class="btn btn-link btn-collapse show-object-features"
                >
                  <span class="more">
                    <i class="icon">
                      <icon-chevron-down />
                    </i>
                    {{ interiorComplete }}
                  </span>
                </a>
                <a
                  v-smooth-scroll="{ duration: 200, updateHistory: false }"
                  v-b-toggle.collapse-object-features
                  href="#ausstattung"
                  class="btn btn-link btn-collapse hide-object-features"
                >
                  <span class="less">
                    <i class="icon icon-only">
                      <icon-chevron-up />
                    </i>
                    {{ interiorComplete }}
                  </span>
                </a>
              </div>
            </div>
          </section>

          <section
            v-if="isSetRecommendations"
            id="recommendation"
          >
            <object-recommendation :recommendation="isSetRecommendations" />
          </section>

          <section
            v-if="availableSections.ratings"
            id="bewertungen"
            ref="sectionRatings"
            class="has-anchor"
          >
            <object-ratings
              :show-select-box-sorted-dates="false"
              @votes-loaded="setAverage"
            />
          </section>
          <section
            v-if="validCoordinates"
            id="lage"
            ref="sectionMap"
            class="has-anchor"
          >
            <object-location
              :position="objectData.position"
              :object-number="objectNumber"
            />
          </section>

          <section
            id="preise"
            ref="sectionCosts"
            class="has-anchor"
          >
            <object-costs
              ref="objectCosts"
              :price-data="priceData"
              :show-date-btn="true"
              :picker-vacancy-data="pickerVacancyData"
            />

            <object-payments
              ref="objectPayments"
              :price-data="priceData"
            />

            <object-cancelations
              v-if="showCancelations"
              ref="objectCancelations"
              :price-data="priceData"
            />
          </section>

          <section
            v-if="objectHasImages"
            id="fotos"
            ref="sectionPhotos"
            class="has-anchor"
          >
            <object-photos
              :photos="objectImages"
              :light-box-ready="lightBoxReady"
              :object-number="objectNumber"
              @open-gallery="openGallery"
            />
          </section>


          <section
            v-if="showContact"
            class="contact has-anchor d-print-none"
          >
            <!-- not removing completely as their might be need for this again -->
            <!-- <faq-note
              v-if="faqNote.show"
              :icon-variant="faqNote.icon"
            /> -->
            <office-contact
              :object-number="activeObjectNumber"
              :start-date="oprhMixin_objectStoreStartDate"
              :end-date="oprhMixin_objectStoreEndDate"
              :template="'OfficeContactCard'"
            />
          </section>

          <div class="d-lg-none bottom-border-social-share-mobile d-print-none">
            <!-- eslint-disable max-len -->
            <social-share-buttons
              v-if="sslbMixin_shareButtonsReady"
              :build-link-wa-mobile="sslbMixin_LinkBuilder(`https://api.whatsapp.com/send?text=${$t('common:share.text',{clientname:clientname})}%20`,'whatsapp')"
              :build-link-fb-msg="sslbMixin_LinkBuilder('fb-messenger://share?link=','facebook-messenger')"
              :build-link-fb="sslbMixin_LinkBuilder('https://www.facebook.com/sharer.php?u=', 'facebook')"
              :build-link-sms="sslbMixin_LinkBuilder(`sms:/?&body=${$t('common:share.text',{clientname:clientname})})}${objectData.title} %20`,'sms')"
              :build-link-email="sslbMixin_eMailLink"
              :build-link-twitter="sslbMixin_LinkBuilder(`https://twitter.com/intent/tweet?text=${$t('common:share.text',{clientname:clientname})}%20`,'twitter')"
              :object-data="objectData"
            />
            <!-- eslint-enable max-len -->
          </div>

          <!-- <div
            v-if="false"
            class="d-none"
          >
            <h2 id="varianten">
              Weitere Varianten dieser Unterkunft
            </h2>
            <ul class="object-variants">
              <li
                v-for="item in 5"
                :key="item"
              >
                <a href="#">
                  <div class="row row-no-pad">
                    <div class="col-4">
                      <div class="img">
                        <img
                          src="https://placeimg.com/150/150/arch"
                          alt=""
                        >
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="content">
                        <div class="title">
                          Ferienwohnung Landidyll mit ...
                        </div>
                        <div class="amenities">
                          (250m<sup>2</sup>, 6 Personen, 2 Schlafz.)
                        </div>
                        <div class="footer">
                          <div class="period">
                            25.05.&nbsp;-&nbsp;01.06.2019
                          </div>
                          <div class="price">
                            439 €
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
              <li class="not-available">
                <a href="#">
                  <div class="row row-no-pad">
                    <div class="col-4">
                      <div class="img">
                        <img
                          src="https://placeimg.com/150/150/arch"
                          alt=""
                        >
                      </div>
                    </div>
                    <div class="col-8">
                      <div class="content">
                        <div class="title">
                          Ferienwohnung Landidyll mit ...
                        </div>
                        <div class="amenities">
                          (250m<sup>2</sup>, 6 Personen, 2 Schlafz.)
                        </div>
                        <div class="footer">
                          <div class="period">
                            25.05.&nbsp;-&nbsp;01.06.2019
                          </div>
                          <div class="price">
                            belegt
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div> -->

          <component-observer
            :placeholder-style="{ height: '325px' }"
            style="margin-bottom: 20px;"
            class="d-print-none"
            @component-intersected="lastSeenObjectsReady = true"
          >
            <!-- set expression lastSeenObjectsCount > 1 (!) because current object included -->
            <last-seen-objects
              v-if="lastSeenObjectsReady && (lastSeenObjectsCount > 1)"
              :exclude="parseInt(objectNumber, 10)"
              title="Zuletzt angesehene Unterkünfte"
              title-class="h3"
              :chunks="{
                xs: 2,
                sm: 3,
                md: 3,
                lg: 4,
                xl: 5,
                other: 6,
              }"
              :variant="variantLastSeenObjects"
            />
          </component-observer>
        </article>

        <aside class="d-none d-lg-block d-print-none">
          <div class="sticky">
            <div class="card">
              <div class="card-body">
                <p class="card-title h5 d-none">
                  {{ $t('object:vacancy.headline') }}
                </p>
                <object-vacancy-form
                  v-if="!isMobile"
                  :available-sections="availableSections"
                  :picker-vacancy-data="pickerVacancyData"
                  @click.native="oprhMixin_forceHydrate"
                />
              </div>
            </div>
            <social-share-buttons
              v-if="sslbMixin_shareButtonsReady"
              :build-link-fb="sslbMixin_LinkBuilder('https://www.facebook.com/sharer.php?u=', 'facebook')"
              :build-link-twitter="sslbMixin_LinkBuilder(`https://twitter.com/intent/tweet?text=${$t('common:share.text',{clientname:clientname})}%20`,'twitter')"
              :build-link-wa-mobile="sslbMixin_LinkBuilder(`https://api.whatsapp.com/send?text=${$t('common:share.text',{clientname:clientname})}%20`,'whatsapp')"
              :build-link-email="sslbMixin_eMailLink"
              :object-data="objectData"
              :show-print-button="true"
            />
          </div>
        </aside>
      </main>

      <object-booking-band
        :picker-vacancy-data="pickerVacancyData"
        @click.native="oprhMixin_forceHydrate"
      />
      <object-vacancy-modal
        class="d-print-none"
        :picker-vacancy-data="pickerVacancyData"
        @click.native="oprhMixin_forceHydrate"
      />
    </div>
    <component
      :is=" oephMixin_errorComponent"
      v-if="oephMixin_loadingError"
      class="d-print-none"
    />
    <div
      v-if="isPrinting"
      class="print-overlay"
    >
      <div class="row">
        <div class="print-spinner col-12">
          <div class="lds-dual-ring" />
        </div>
        <div class="print-text">
          <div> {{ $t('object:print.printStarted') }} </div>
          <div class="text-center">
            {{ $t('object:print.pleaseWait') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/** CONFIG  */
import agencyCookies from 'config/cookieDrop';
import imagesConfig from 'config/images';

import { mapGetters } from 'vuex';
import ObjectInternals from 'components/ObjectInternals.vue';
import ObjectLoading from 'components/loading/ObjectLoading.vue';
import HeaderLayout from 'components/Header.vue';
import ObjectBreadcrumb from 'components/ObjectBreadcrumb.vue';
import ObjectDescription from 'components/ObjectDescription.vue';
import ObjectVacancyForm from 'components/ObjectVacancyForm.vue';
import StvDtvRating from 'components/StvDtvRating.vue';
import ObjectBookingBand from 'components/ObjectBookingBand.vue';
import ObjectAexea from 'components/ObjectAexea.vue';
import ObjectFeatures from 'components/ObjectFeatures.vue';
import ObjectNavbar from 'components/ObjectNavbar.vue';
import SearchCapacity from 'components/SearchCapacity.vue';
import WatchBtn from 'components/WatchBtn.vue';
import ShareBtn from 'components/ShareBtn.vue';
import ComponentObserver from 'components/loading/ComponentObserver.vue';
import AgencyCookieDrop from 'components/AgencyCookieDrop.vue';
import { BCollapse, VBToggle } from 'bootstrap-vue';
import EncouragementAlert from 'components/EncouragementAlert.vue';
import agencyInfo from 'components/ObjectAgencyInfo.vue';
import ObjectShareModal from 'components/ObjectShareModal.vue';
import Error404 from 'components/errors/Error404Content.vue';
import Error410 from 'components/errors/Error410Content.vue';
import Error500 from 'components/errors/Error500Content.vue';
import ObjectRecommendation from 'components/ObjectRecommendation.vue';

/** Multi Client Components */
// import ImageGalleryGrid from 'components/ImageGalleryGrid.vue';
// import ImageGallerySlide from 'components/ImageGallerySlide.vue';

/* ICONS */
import IconChevronDown from 'ICON:IconChevronDown';
import IconChevronUp from 'ICON:IconChevronUp';
import IconThumbsUp from 'ICON:IconThumbsUp';
/* MIXINS */
import ActiveObjectStore from 'mixins/ActiveObjectStore';
import ObjectData from 'mixins/ObjectData';
import IntersectionObserverHelper from 'mixins/IntersectionObserverHelper';
import ObjectPriceRequestHelper from 'mixins/ObjectPriceRequestHelper';
import DeviceHelper from 'mixins/DeviceHelper';
import GtmTools from 'mixins/GtmTools';
import PriceRequestHelper from 'mixins/PriceRequestHelper';
import LoadingLogic from 'mixins/LoadingLogic';
import ImageLoader from 'mixins/ImageLoader';
import SocialShareLinkBuilder from 'mixins/SocialShareLinkBuilder';
import HeadingSizeHelper from 'mixins/HeadingSizeHelper';
import ResetApiHttpStatus from 'mixins/ResetApiHttpStatus';
import UserApi from 'mixins/UserApi';
import cancelable from 'mixins/cancelable';
import { printSetup } from 'mixins/PrintPage';
import ObjectErrorPageHandler from 'mixins/ObjectErrorPageHandler';
import hydrateOrObserveWhenVisible from 'utils/hydrateOrObserveWhenVisible';
import { fromAPIDateString } from 'utils/DateHelper';
import { differenceInCalendarDays } from 'date-fns';
import Sentry from 'plugins/sentry.TARGET';


import config from 'config/appConfig';

export default {
  name: 'ObjectPage',
  metaInfo() {
    return this.metaData;
  },
  components: {
    ObjectShareModal,
    SocialShareButtons: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-ossbu" */ 'components/SocialShareButtons.vue')),
    ObjectLoading,
    BCollapse,
    EncouragementAlert,
    ObjectBreadcrumb,
    ObjectDescription,
    ObjectFeatures,
    LightBoxPinch: () => import(/* webpackChunkName: "light-box-pinch" */ 'components/LightBoxPinch.vue'),
    ObjectPhotos: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-oopho" */ 'components/ObjectPhotos.vue')),
    HeaderLayout,
    ObjectVacancyForm,
    ObjectLocation: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-ooloc" */ 'components/ObjectLocation.vue')),
    LastSeenObjects: () => import(/* webpackChunkName: "last-seen-objects" */ 'components/LastSeenObjects.vue'),
    InfoBanner: () => import(/* webpackChunkName: "info-banner" */ 'components/InfoBanner.vue'),
    Error404,
    Error410,
    Error500,
    OfficeContact: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-oocon" */ 'components/OfficeContact.vue')),
    ObjectAexea,
    ComponentObserver,
    ObjectRatings: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-oorat" */ 'components/ObjectRatings.vue')),
    StvDtvRating,
    SearchOffer: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-osoff" */ 'components/SearchOffer.vue')),
    ObjectPartner: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-oopar" */ 'components/ObjectPartner.vue')),
    ObjectCosts: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-oocos" */ 'components/ObjectCosts.vue')),
    ObjectNavbar,
    ObjectBookingBand,
    SearchCapacity,
    AgencyCookieDrop,
    WatchBtn,
    ShareBtn,
    IconChevronDown,
    IconChevronUp,
    IconThumbsUp,
    ObjectPayments: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-oopay" */ 'components/ObjectPayments.vue')),
    ObjectCancelations: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-oocanc" */ 'components/ObjectCancelations.vue')),
    agencyInfo,
    ObjectInternals,
    ObjectVacancyModal: () => import(/* webpackChunkName: "object-vacancy-modal" */ 'components/ObjectVacancyModal.vue'),
    ImageGallery: () => {
      switch (imagesConfig.objectImageGallery) {
        case 'grid':
          return import(/* webpackChunkName: "image-gallery-grid" */ 'components/ImageGalleryGrid.vue');
        case 'slide':
          return import(/* webpackChunkName: "image-gallery-slide" */ 'components/ImageGallerySlide.vue');
        default:
          return import(/* webpackChunkName: "image-gallery-grid" */ 'components/ImageGalleryGrid.vue');
      }
    },
    // FaqNote: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-oor" */ 'components/FaqNote.vue')),
    // ObjectRkiNotes: hydrateOrObserveWhenVisible(() => import(/* webpackChunkName: "lazyhydrate-orki" */ 'components/ObjectRkiNotes.vue')),
    ObjectRecommendation,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [
    ObjectData,
    IntersectionObserverHelper,
    PriceRequestHelper,
    ObjectPriceRequestHelper,
    LoadingLogic,
    ActiveObjectStore,
    ImageLoader,
    SocialShareLinkBuilder,
    DeviceHelper,
    HeadingSizeHelper,
    GtmTools,
    ResetApiHttpStatus,
    UserApi,
    cancelable,
    printSetup,
    ObjectErrorPageHandler
  ],
  i18nOptions: { namespaces: ['object', 'flatpickr', 'date', 'booking', 'serviceunits', 'objectDescription', 'amenities', 'rating', 'errors'] },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRouteName = from.name;
    });
  },
  props: {
    objectNumber: {
      required: true,
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ready: false,
      average: 0,
      smoothScrollReady: false,
      lightBoxReady: false,
      lastSeenObjectsReady: false,
      mapReady: false,
      modalReady: false,
      addCanonical: true,
      dataLayerReady: false,
      agencyCookies,
      imageIndexPinch: false,
      showLightboxPinch: false,
      objectLoadingReady: false,
      interiorVisible: false,
      showCancelations: config.object.showCancelations,
      showPartner: config.object.showPartner,
      prevRouteName: '',
      positionLastSeenObjects: config.object.positionLastSeenObjects,
    };
  },
  computed: {
    locationName() {
      try {
        if (this.objectData.locations?.region) {
          return this.objectData.locations.region;
        }
      } catch (e) {
        console.error(e.message);
        return '';
      }
      return '';
    },
    niceReviewText() {
      // Text bei Note 5.0:
      const best = this.$t('object:goodChoice.best');
      // Text bei Note 4.8 - 4.9:
      const verygood = this.$t('object:goodChoice.verygood', { locationName: this.locationName });
      // Text bei Note 4.6 - 4.7:
      const good = this.$t('object:goodChoice.good');

      if (this.ratingAverage >= 4.6 && this.ratingCount >= 3) {
        const rest = (5 * 100 - this.ratingAverage * 100) / 100;
        if (rest === 0) {
          return best;
        } if (rest < 0.3) {
          return verygood;
        }
        return good;
      }
      return false;
    },
    objectFeatureDescription() {
      // get feature description from object store
      return this.getObjectFeatureDescription();
    },
    configData() {
      return config.object;
    },
    // locale wasnt properly updating because of the toggle
    interiorComplete() {
      let locale = this.$t('objectDescription:interiorComplete');

      if (this.interiorVisible) {
        locale = this.$t('objectDescription:showLess');
      }
      return locale;
    },
    errorText() {
      if (this.$store.getters.getApiHttpStatus('object') === 404) {
        return this.$store.getters.getErrorTextObject();
      }
      return '';
    },
    withCookieDropping() {
      return agencyCookies.some((agency) => agency.agencyNumber === this.agencyId);
    },
    ...mapGetters([
      'hasObjectDataByKey',
      'getPriceByKey',
      'getObjectFeatureDescription',
      'getCurrentDescriptionLanguage',
    ]),
    // @vuese
    // vacancy data from the object store
    objectVacancyData() { return this.objectData.availability; },
    // @vuese
    // build the vacancy data used by the flatpickr
    // @type Object
    pickerVacancyData() {
      return this.prhMixin_getVacancyData( // from ObjectPriceRequestHelper
        this.hasObjectVacancy, // from ActiveObjectStore
        this.objectVacancyData, // ,
        // this.objectSeasonData,
      );
    },
    agencyId() {
      const agencyid = this.getObjectDataByKey('agency') || null;

      if (agencyid) {
        return agencyid;
      }
      return false;
    },
    providerType() {
      const providerType = this.getObjectDataByKey('providerType') || null;

      if (providerType) {
        return providerType;
      }
      return false;
    },
    objectHasImages() {
      let hasImages = true;
      if (this.getObjectDataByKey('images')
        && this.getObjectDataByKey('images').length
        && this.getObjectDataByKey('images')[0]
        && this.getObjectDataByKey('images')[0].src === '') {
        hasImages = false;
      }
      return hasImages;
    },
    objectFirstImage() { // get/set first image; currently only for og meta information
      let firstImage = null;
      if (this.getObjectDataByKey('images')
        && this.getObjectDataByKey('images').length
        && this.getObjectDataByKey('images')[0]
        && this.getObjectDataByKey('images')[0].src !== '') {
        firstImage = this.imageLoader('975x740', this.getObjectDataByKey('images')[0].src, this.objectData.objectNumber, this.getObjectDataByKey('images')[0].cdn);
      }
      return firstImage;
    },
    // @vuese
    // price data that this component is using
    priceData() {
      return this.$store.getters.getPriceByKey(this.oprhMixin_identifierKey);
    },
    objectHasPriceData() {
      // returns true if price request with persons, startdate and enddate was successful
      // or if object has additional costs text
      const { descAdditional } = this.$store.getters.getActiveObjectData;
      if (this.priceData.priceObject.price || (descAdditional && (descAdditional.costs || descAdditional.costsText))) {
        return true;
      }
      return false;
    },
    objectIsLoading() {
      return !this.hasObjectData || this.objectNumber !== this.activeObjectNumber;
    },
    objectImages() {
      if (this.objectHasImages) {
        return this.objectData.images;
      }
      return [];
    },
    galleryLightboxArr() {
      const images = [];
      if (this.objectHasImages) {
        this.objectImages.forEach((img) => {
          images.push({
            description: `${img.description}`,
            no: img.no,
            srcOrigin: img.src,
            cdn: img.cdn,
          });
        });
      }
      return images;
    },
    availableSections() {
      /**
       * check if object has certain sections available
       * show/hide section and navigation link, depending on available
       */
      const sections = {};

      sections.highlights = {
        id: 'highlights',
        label: this.$t('common:highlights'),
        container: '#highlights',
        ref: 'sectionHighlights',
        sort: 0,
      };
      sections.description = {
        id: 'description',
        label: this.$t('object:description'),
        container: '#beschreibung',
        ref: 'sectionDescription',
        sort: 1,
      };
      sections.features = {
        id: 'features',
        label: this.$t('object:interior'),
        container: '#ausstattung',
        ref: 'sectionFeatures',
        sort: 2,
      };

      if (this.getObjectDataByKey('ratingCount') > 0) {
        sections.ratings = {
          id: 'ratings',
          label: this.$t('object:ratings'),
          container: '#bewertungen',
          ref: 'sectionRatings',
          sort: 3,
        };
      }
      if (this.validCoordinates) {
        sections.map = {
          id: 'map',
          label: this.$t('object:position'),
          container: '#lage',
          ref: 'sectionMap',
          sort: 4,
        };
      }
      // EDVUE-415 always show price section
      sections.costs = {
        id: 'costs',
        label: this.$t('object:objectPrices'),
        container: '#preise',
        ref: 'sectionCosts',
        sort: 5,
      };

      if (this.objectHasImages) {
        sections.photos = {
          id: 'photos',
          label: this.$t('object:objectPhotos.photos'),
          container: '#fotos',
          ref: 'sectionPhotos',
          sort: 6,
        };
      }
      return sections;
    },
    isMobile() {
      // check for mobile breakpoints up to md
      return ['xs', 'sm', 'md'].includes(this.dh_breakpoint);
    },
    largeDevice() {
      return !['xs', 'sm'].includes(this.dh_breakpoint);
    },
    lastSeenObjectsCount() {
      return this.$store.getters.getLastSeenObjects.length;
    },
    regions() {
      const breadCrumb = this.objectData.breadcrumb;
      const regions = breadCrumb.filter((item) => item.id && item.name !== this.PlaceName);
      return regions || [];
    },
    validCoordinates() {
      const coordinates = this.getObjectDataByKey('position');
      const lat = Math.abs(coordinates?.lat);
      const lon = Math.abs(coordinates?.lon);
      if (lat + lon > 0) {
        return true;
      }
      return false;
    },
    userDataReady() {
      return this.$store.getters.userDataStatus;
    },
    uidAndObjectReady() {
      return (this.UserApi_uid && this.objectLoadingReady === true);
    },
    clientname() {
      if (this.$store.getters.getPartnerConfigValue('partnerName') !== '') return this.$store.getters.getPartnerConfigValue('partnerName').replace('&', 'und');
      return process.env.CLIENTNAME;
    },
    currentLanguage() {
      return this.$store.state.app.currentLanguage;
    },
    // not removing completely as their might be need for this again
    // faqNote() {
    //   return {
    //     show: config.object.faqNote.visible,
    //     icon: config.object.faqNote.iconVariant,
    //   };
    // },
    variantLastSeenObjects() {
      let variant = '';
      if (this.positionLastSeenObjects) {
        variant = this.positionLastSeenObjects;
      }
      return variant;
    },
    showContact() {
      if (this.$store.getters.getPartnerConfigValue('partnerID') !== '') return false;
      return true;
    },
    isPrinting() {
      return this.$store.getters.getPrintBool;
    },
    printingHasError() {
      return this.$store.getters.getPrintError;
    },
    isSetRecommendations() {
      if (this.objectData?.recommendation) {
        return this.objectData.recommendation;
      }
      return false;
    },
  },
  watch: {
    objectNumber: {
      handler: 'getObject',
    },
    currentLanguage: {
      handler: 'reloadLanguage',
    },
    watch: {
      $route: 'resetApiHttpStatus',
    },
    uidAndObjectReady: {
      handler: 'addToLastSeenObjects',
    },
    userDataReady: {
      handler: 'recommendationPricerequest',
    },
  },
  created() {
    this.llMixin_addComponentLoadingIndicator('objectIsLoading');
  },
  mounted() {
    this.modalReady = true;
    this.lightBoxReady = true;
    this.addCanonical = false;
    if (!this.oephMixin_loadingError) {
      this.getObject()
        .then(() => {
          // check if current URL is SEO Url, otherwise redirect
          let objectSEOLink = this.getObjectDataByKey('SEOLinks').object;
          // add languagecode
          if (config.locales.standardLanguage !== this.$store.state.app.currentLanguage) {
            objectSEOLink = `/${this.$store.state.app.currentLanguage}${objectSEOLink}`;
          }
          const slashFixSeo = objectSEOLink.replace(/\/+$/i, '');
          const slashFixRoute = this.$route.path.replace(/\/+$/i, '');
          if (objectSEOLink && encodeURI(slashFixSeo) !== slashFixRoute) {
            this.$router.push({ path: encodeURI(objectSEOLink), query: this.$router.currentRoute.query });
          }
        })
        .then(() => {
          this.objectLoadingReady = true;
          if (this.hasObjectVacancy) {
            if (this.$store.getters.getApiHttpStatus('priceRequest') !== 500) this.oprhMixin_initialPriceRequest();
            else {
              this.oprhMixin_initialPriceRequest({
                startDate: null,
                endDate: null,
                persons: 2,
                language: this.$store.getters.getCurrentLanguage,
              });
              this.oprhMixin_showErrorToast();
            }
          }
        })
        .catch((err) => {
          this.oephMixin_apiErrorHandler(err);
        });
    }
  },
  // Server-side only
  // This will be called by the server renderer automatically
  serverPrefetch() {
    // return the Promise from the action
    // so that the component waits before rendering
    return this.getObject().then(() => {
      this.objectLoadingReady = true;
      let objectSEOLink = this.getObjectDataByKey('SEOLinks').object;
      if (config.locales.standardLanguage !== this.$store.state.app.currentLanguage) {
        objectSEOLink = `/${this.$store.state.app.currentLanguage}${objectSEOLink}`;
      }
      const slashFixSeo = objectSEOLink.replace(/\/+$/i, '');
      const slashFixRoute = this.$route.path.replace(/\/+$/i, '');
      if (objectSEOLink && (encodeURI(slashFixSeo) !== slashFixRoute/* || slashFixSeo !== slashFixRoute */)) {
        let newUrl = objectSEOLink;
        if (this.$router.currentRoute.query) {
          const queryString = Object.keys(this.$router.currentRoute.query).map((key) => `${key}=${this.$router.currentRoute.query[key]}`).join('&');
          if (queryString !== '') {
            newUrl = `${newUrl}?${queryString}`;
          }
        }
        this.$store.commit('SET_APP_HTTPREWIRTEURL', newUrl);
        this.$store.commit('SET_APP_HTTPSTATUS', 301);
      }

      if (this.hasObjectVacancy) return this.oprhMixin_initialPriceRequest();
      return Promise.resolve();
    }).catch((err) => {
      this.oephMixin_apiErrorHandler(err);
      const { status = 500 } = err;
      this.$store.commit('SET_APP_HTTPSTATUS', status);
      this.$store.commit('SET_APP_APIHTTPSTATUS', { type: 'object', status });
    });
  },
  methods: {
    getRegionsData(ident) {
      const regionCopy = this.regions.slice(); // get copy from breadcrumb data
      if (regionCopy) {
        if (regionCopy[ident.idx]) {
          return regionCopy[ident.idx][ident.prop];
        }
      }
      return null;
    },
    dlPush() {
      const objectType = this.$t(`amenities:${this.getObjectDataByKey('objectType')}`) || 'Ferienhaus';
      // data from mixin ObjectData.js

      this.dataLayerPush( // EDVUE-420 Relaunch: Tracking - dataLayer Objektseite
        {
          CountryISO: this.CountryISO, // (ISO des Landes)
          CountryName: this.CountryName, // (Name des Landes)
          RegionID: this.RegionID, // (ID der Region)
          RegionName: this.RegionName, // (Name der Region)
          Region1ID: this.getRegionsData({ prop: 'id', idx: 0 }),
          Region1Name: this.getRegionsData({ prop: 'name', idx: 0 }),
          Region2ID: this.getRegionsData({ prop: 'id', idx: 1 }),
          Region2Name: this.getRegionsData({ prop: 'name', idx: 1 }),
          Region3ID: this.getRegionsData({ prop: 'id', idx: 2 }),
          Region3Name: this.getRegionsData({ prop: 'name', idx: 2 }),
          PlaceID: this.PlaceID, // (ID des Orts)
          PlaceName: this.PlaceName, // (Name des Orts)
          objectNumber: this.objectNumber,
          objectType, // (Ferienhaus / Ferienwohnung / ...)
          priceMin: this.priceMin, // (Ab-Preis)
          ratingCount: this.ratingCount, // (Anzahl der Bewertungen)
          ratingAverage: this.ratingAverage, // (durchschn. Bewertung)
          operator: this.operator, // (Veranstalter)
          pets: this.pets, // (erlaubt = 1, verboten = 0)
          pool: this.pool, // (vorhanden = 1, nicht vorhanden = 0)
          personsMax: this.personsMax, // (Anzahl mögliche Personen)
          lakeside: this.objectData.lakeside, // near lake 0/1
          seaside: this.objectData.seaside, // near sea 0/1 dist <= 1km
        },
      );
      this.dataLayerReady = true;
    },
    gtmContentGroupPush() {
      const objectType = this.$t(`amenities:${this.getObjectDataByKey('objectType')}`) || 'Ferienhaus';
      const countryCode = this.getObjectDataByKey('locations').countryCode || 'XX';
      this.dataLayerPush( // gtm dataLayer push based on EDVUE-156
        {
          event: 'contentGroupPush',
          ContentGroupIndex: 3,
          ContentGroup: 'Objektseite',
          ContentGroupData: `${objectType}:${countryCode}:${this.objectNumber}`,
        },
      );
    },
    // tell store to load object and save it in $store.state.Objects
    getObject(objectNumber = this.objectNumber) {
      return this.$store.dispatch('GET_OBJECT', { objectNumber })
        .then(() => {
          this.$store.commit('SET_ACTIVE_OBJECT', { objectNumber });
          this.dlPush();
        });
    },
    addToLastSeenObjects() {
      // lastSeenObject set must be AFTER object data is saved in vuex store
      if (this.uidAndObjectReady) {
        if (this.$store.getters.getObjectDataByKey('active')) {
          this.$store.dispatch('ADD_TO_LASTSEENOBJECTS', {
            objectData: {
              objectNumber: this.objectNumber,
              agencyID: this.agencyId,
              providerType: this.providerType,
              prevRouteName: this.prevRouteName || '',
              startDate: this.$route.query?.startDate,
              endDate: this.$route.query?.endDate,
              persons: this.$route.query?.persons || 2,
              ratingAverage: this.ratingAverage || -1,
            },
          }).catch(() => {});
        }
      }
    },
    setAverage(votes) {
      this.average = votes.avg;
    },
    openGallery(indexParam) {
      // GTM
      this.$gtm.trackEvent({
        event: null, // Event type [default = 'interaction'] (Optional)
        category: 'Object',
        action: 'open_gallery',
        label: 'Lightgallery opened',
        value: 1,
        noninteraction: false, // Optional
      });

      this.imageIndexPinch = parseInt(indexParam, 10);
      this.showLightboxPinch = true;
    },
    // tell store to load object and save it in $store.state.Objects
    reloadLanguage() {
      this.$store.dispatch('RESET_OBJECTS');
      return this.getObject(this.objectNumber).then(() => {
        if (this.hasObjectVacancy) this.oprhMixin_initialPriceRequest();
      })
        .catch((err) => {
          this.oephMixin_apiErrorHandler(err);
        });
    },
    recommendationPricerequest() {
      // on b2b wlv: send pricerequest with uid and jwt to show recommendation btn
      // must happen after user data is ready because no user specific requests on ssr
      if (this.userDataReady && this.UserApi_checkPermission('pricerequest.showRecommendation')) {
        const partner = this.$store.getters.getPartnerConfigValue('partnerID');
        const duration = differenceInCalendarDays(
          fromAPIDateString(this.$route.query?.endDate),
          fromAPIDateString(this.$route.query?.startDate),
        );

        // duration is required in API
        if (duration) {
          this.$store.dispatch('GET_PRICE', {
            startDate: this.$route.query?.startDate,
            endDate: this.$route.query?.endDate,
            persons: this.$route.query?.persons,
            duration,
            language: this.$store.getters.getCurrentLanguage,
            uid: this.UserApi_uid,
            jwt: this.UserApi_jwt,
            partner,
            objectNumber: this.objectNumber,
            forceRequest: true,
          }).finally(() => {
            this.$store.commit('SET_OBJECT_PRICE_IDENTIFIER_KEY', { partner });
          }).catch((error) => {
            if (process.env.NODE_ENV === 'production') {
              Sentry.captureException(error);
            } else {
            // eslint-disable-next-line no-console
              console.error(error);
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky {
  /* flatpickr overlaps and this is the z-index its using because it's inside sticky */

  /* leaflet has 1000 */

  /* watch button has 1101 */
  z-index: 1102;
}

.modalInFront {
  // used to set modal in front if activated
  z-index: 2002; //sticky header has 2000;
}

.gallery-grid-container {
  position: relative;
}

.partner {
  margin: 2em 0 0;
}

/deep/ .booking-band {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 2002; //sticky header has 2000;

  @include box_shadow;

  @media #{$media_lg_min} {
    display: none;
  }

  .booking-band-body {
    padding: $margin_content_xs $margin_content;

    @media #{$media_xs} {
      padding: 0.5*$margin_content_xs $margin_content_xs;
    }

    .object-price {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .price-min {
        .price-period {
          text-align: left;
        }
      }

      .object-price-duration {
        order: 2;
      }

      .object-price-original {
        order: 1;

        del {
          text-align: left;
        }

        em {
          margin-left: 0;
        }
      }
    }

    .btn-link-date {
      padding-left: 0;
    }

    .btn-primary {
      margin: 0.25em 0 0.5em;
    }
  }

  .rating-stars {
    display: flex;
    justify-content: center;
    margin: 0.25em 0 0.5em;
  }
}

.gallery-badge {
  background: var(--color_ci);
  color: #fff;
  padding: 0.25em 0.75em;
  position: absolute;
  left: 0;
  top: 1.5em;
  display: inline-block;
  z-index: 10;

  @include font_bold;
}

.object-map {
  .toolbar {
    display: none;
  }
}

.ratingDTVSTV {
  cursor: pointer;
}

.logoDTVSTV {
  cursor: pointer;
}

.object-variants {
  padding: 0;
  display: grid;
  grid-gap: $margin_content;
  margin: 0 0 $margin_content;
  grid-template-columns: repeat(2, 1fr);

  @media #{$media_lg} {
    grid-template-columns: 1fr;
  }

  @media #{$media_sm_max} {
    grid-template-columns: 1fr;
  }

  li {
    border: 1px solid $color_grey_100;
    list-style: none;
    padding: 0;
    margin: 0;
    display: block;

    @include radius($radius_card);

    overflow: hidden;

    a {
      text-decoration: none;
      color: inherit;
      display: block;
      position: relative;
      background: #fff;
      border: none;
    }

    &.not-available {
      opacity: 0.7;
      filter: grayscale(100%);
    }

    .img {
      margin: 10px 0 10px 10px;

      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    .content {
      padding: $margin-content;

      .title {
        margin: -0.25em 0 0.5em;

        @include font_bold;

        font-size: $font_size_m !important;
        line-height: 1.2em;
      }

      .amenities {
        font-size: $font_size_s;
        line-height: 1.2em;
        margin: 0 0 3em;
      }

      .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        padding: $margin_content;

        .period {
          @extend %text-muted;

          float: left;
          font-size: $font_size_s;
        }

        .price {
          float: right;

          @include font_bold;
        }
      }
    }
  }
}

.card .alert-distinction {
  margin: -1px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  div {
    @include font_size_s;
  }
}

.object-breadcrumbs {
  padding-top: $margin_content_xs;
  padding-bottom: $margin_content_xs;
}

.object-features,
.object-distinctions {
  margin: 0;
  padding: 0;
  overflow: hidden;
  display: none;

  @media #{$media_sm_min} {
    border-top-left-radius: $radius_card;
    border-top-right-radius: $radius_card;

    .card & {
      margin: -1px;
    }
  }

  article & {
    display: none;

    @media #{$media_xs} {
      display: block;
      margin-left: -$margin_content_xs;
      margin-right: -$margin_content_xs;
    }
  }

  li {
    display: table;
    margin: 0;
    width: 100%;
    padding: 10px $margin_content_xs;
    background: $color_ci_complement;
    color: #fff;

    .icon {
      display: table-cell;
      vertical-align: middle;
      line-height: 1em;
      margin: 0;
      padding: 0 0.25em 0 0;
      font-size: $font_size_xxl;
      width: 1em;
    }

    h4,
    h5 {
      display: table-cell;
      vertical-align: middle;

      @include font_bold;

      font-size: $font_size_s;
      margin: 0;
      color: inherit;
    }

    p {
      margin: 0;
    }
  }
}

/deep/ .bottom-border-social-share-mobile {
  border-bottom: 1px solid $color_grey_100;
  border-top: 1px solid $color_grey_100;

}

h1 {
  line-height: 1.1em;
  margin: 0.5em 0 0.15em !important;
}

/deep/ .objectDescriptionFeatures {
  h3 {
    margin: 1em 0 0.5em;
  }

  ul {
    margin: 0;
    padding: 0 0 0 1.1em;

    li {
      line-height: 1.3em;
      margin: 0 0 0.3em;

      ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
      }
    }
  }
}

section.contact {
  margin-top: 2*$margin_content;
}

.object-options {
  right: 15px;
  position: absolute;
  top: 0;
  width: 100px;
  height: 70px;
}

/deep/ article .alert-distinction {
  margin-bottom: $half_margin_content;

  @media #{$media_xs} {
    margin: -$margin_content_xs;
    margin-top: 0;
    margin-bottom: 0;

    @include radius(0);
  }

  @media #{$media_lg_min} {
    display: none;
  }
}

.print-overlay {
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  height: 100%;
}

.print-text {
  color: white;
  margin-left: 39.5%;
}

.print-spinner {
  margin-top: 25%;
  margin-left: 42%;
}

.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}

.lds-dual-ring::after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 6px solid #fff;
  border-color: var(--color_ci) transparent var(--color_ci) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
// is overwritten here again as the extra padding seems to be needed on home
/deep/ #objects-last-seen{
  padding: 0;
}
</style>

<style lang="scss" src="@/scss/components/object/Object.scss" scoped clientextend></style>


